import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',
};

export const slice = createSlice({
  name: 'nft',
  initialState,
  reducers: {
    handleStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});

export default slice.reducer;
